import { useEffect } from 'react';

export function useWakeLock(enabled: boolean): void {
    useEffect(() => {
        if (enabled) {
            return requestWakeLock();
        }
    }, [enabled]);
}

function requestWakeLock(): (() => void) | undefined {
    const isSupported = typeof window !== 'undefined' && 'wakeLock' in navigator;
    if (!isSupported) {
        return;
    }

    const pendingInstance = (async () => {
        try {
            return await navigator.wakeLock.request('screen');
        } catch {
            // catching as a guard for possible edge cases
        }
    })();

    return () => {
        void (async () => {
            try {
                const instance = await pendingInstance;
                await instance?.release();
            } catch {
                // catching as a guard for possible edge cases
            }
        })();
    };
}
